import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter} from "react-router-dom";
import _ from 'lodash';
import queryString from 'query-string';
import {clearUploadErrors} from 'store/state/cashflows';
import { withStyles } from "@material-ui/core/styles";
import {
  IconButton, Dialog, DialogTitle, DialogContent,
  Button,
  CircularProgress,
  Fade,
  DialogActions,
  Grid,
} from "@material-ui/core";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import FileUpload from 'components/Files/Upload';
import PrimaryButton from 'components/Global/Buttons/PrimaryButton';

const Spacer = styled.div`
  flex-grow:1;
`
const Description = styled.div`
  color: rgba(0, 0, 0, 0.537);
  padding-bottom:20px;
`;
const ValidationGrid = styled(Grid)`
  && {
    height:264px;
  }
`
const ValidationComment = styled.div`
  color: rgba(0, 0, 0, 0.537);
`
const StyledCancelButton = styled(PrimaryButton)`
  &&& {
    margin-right:12px;
  }
`
export const VerticalDivider = styled.div`
  height:100%;
  border-right: 1px solid #cccccc;
`;
const Error = styled.div`
  color:#ff0000;
  font-size:17px;
  padding-left:8px;
`

const StyledDialogActions = styled(DialogActions)`
  && {
    justify-content: flex-end;
  }
  `

  const styles = theme => ({
    customPaperWidthMd: {
      maxWidth:'780px',
      minWidth: '750px'
    }
  });

class OverrideCashflowsModal extends Component {    
  close = () => {    
    this.props.clearUploadErrors();
    this.props.onClose();
  }
  render() {            
    const { classes, isOpen, cashflowType, downloadElements, onOverride,errorMessage, showSpinner } = this.props;                  
    return (
      <Fragment>
        <Dialog 
          classes={
            {
              paperWidthMd: classes.customPaperWidthMd
            }
          } 
          open={isOpen} 
          onClose={this.close} 
          maxWidth="md">
          <Grid
            container            
            alignItems="center"
            justify="space-between"
          >
            <DialogTitle>Edit Cashflows</DialogTitle>
            <IconButton style={{ marginRight: 16 }} onClick={this.close}>
              <CloseIcon style={{ fontSize: 36 }} />
            </IconButton>
          </Grid>          
          <DialogContent>            
            {!showSpinner && <Grid container spacing={8} justify="space-between">
              <Grid item container xs={5}>
                <Description>Click to download the correct template for the values you are trying to edit:</Description>
                {downloadElements}
              </Grid>              
              <Grid item>
                <VerticalDivider/> 
              </Grid>
              <Grid item container xs={5} >
                <Description>Choose an edited template to upload:</Description>
                <FileUpload onDrop={onOverride}/>
              </Grid>
            </Grid>}
            {showSpinner && (
            <ValidationGrid direction="column" container justify="center" alignItems="center" spacing={16}>
                <Grid item>
                  <CircularProgress size={120} thickness={1}/>
                </Grid>
                <Grid item>                  
                  <ValidationComment>Validating file..</ValidationComment>              
                </Grid>
            </ValidationGrid>
            )}
          </DialogContent>
          <StyledDialogActions>            
            <Fade in={!!errorMessage}>
              <Error>{errorMessage}</Error>
            </Fade>
            <Spacer></Spacer>
            <Fragment>
              <StyledCancelButton onClick={this.close}>Cancel</StyledCancelButton>              
            </Fragment>
          </StyledDialogActions>
        </Dialog>
      </Fragment>
    )
  }
}
const mapStateToProps = ({cashflows }) => ({    
  errorMessage: cashflows.uploadErrorMessage,
  showSpinner: cashflows.showSpinner
});

export default compose(
  withRouter,
  connect(mapStateToProps, {clearUploadErrors}),
  withStyles(styles) 
)(OverrideCashflowsModal);
